import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ReactPixel } from '../../helpers';
import Footer from '../../components/Footer/Footer';
import { MainBodyWrapper, RootWrapper } from './styled';
import '../css_global/styles.css';
import EuCookieBanner from '../../components_common/EuCookieBanner/EuCookieBanner';
import policyActions from '../../common/actions/policyActions';
import UnsupportedBrowser from '../../components_common/UnsupportedBrowser/UnsupportedBrowser';
import checkUnsupportedBrowser from '../../helpers/checkUnsupportedBrowser';
import Banner from '../../components_common/Banner';
import Header from '../../components/Header/Header';

const mapStateToProps = ({
  api: {
    basePathWeb,
    countryIso,
    fbOg,
    freeShipping,
    yotpoKey,
    metadescription,
    page,
    product,
    title,
    isEu,
    euCookiePolicyAccepted,
  },
  overflowScroll,
}) => ({
  basePathWeb,
  countryIso,
  fbOg,
  freeShipping,
  yotpoKey,
  metadescription,
  overflowScroll,
  page,
  product,
  title,
  isEu,
  euCookiePolicyAccepted,
});

const mapDispatchToProps = dispatch => ({
  acceptCookies: () => {
    dispatch(policyActions());
  },
});

class AppComponent extends Component {
  render() {
    const {
      acceptCookies,
      countryIso,
      euCookiePolicyAccepted,
      freeShipping,
      isEu,
      overflowScroll,
      page,
      children,
      currPage,
    } = this.props;

    const { browserIsNotSupported, browserName } = checkUnsupportedBrowser();

    const isAuthenticationPage = page === 'Authentication';

    const overflowy = page === 'Home';
    return (
      <RootWrapper>
        <Banner desktop country={countryIso} freeShipping={freeShipping} />
        <Header currPage={currPage} />
        <MainBodyWrapper id="main" overflowy={overflowy} overflowScroll={overflowScroll}>
          {browserIsNotSupported ? <UnsupportedBrowser isDesktop browserName={browserName} /> : <>{children}</>}
        </MainBodyWrapper>
        {isEu && !euCookiePolicyAccepted && <EuCookieBanner isDesktop handleClick={acceptCookies} />}
        <Footer showNewsletterForm={!isAuthenticationPage} />
      </RootWrapper>
    );
  }
}

AppComponent.propTypes = {
  acceptCookies: PropTypes.func.isRequired,
  euCookiePolicyAccepted: PropTypes.bool,
  isEu: PropTypes.bool,
  page: PropTypes.string.isRequired,
  metadata: PropTypes.shape({
    title: PropTypes.func,
    description: PropTypes.func,
  }),
};

const AppDesktop = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppComponent);
export { AppDesktop as default, AppComponent };
